module.exports = __webpack_public_path__ + "img/34. N V Rajiv1.20f3c94a.jpg";